// 開発用ページ（/drawing-builder・/capture-figures）から Flask を呼ぶ処理。
// 学習者が使う画面からは呼ばない（実験当日は Flask なしで動く）。
const apiUrl = () => process.env.REACT_APP_API_URL || 'http://localhost:5000';

// 3Dモデルの描画を Flask の /reverse でデッサン風画像（エッジ抽出）にする
export async function toDrawing(blob) {
  const form = new FormData();
  form.append('file', blob, 'render.png');
  const res = await fetch(`${apiUrl()}/reverse`, { method: 'POST', body: form });
  if (!res.ok) throw new Error(`/reverse ${res.status}`);
  return res.blob();
}

// PNG を Flask の /capture で保存する。
// dest='captures' … research/_captures/（研究資料の図版）
// dest='dessin'   … frontend/public/dessin/（学習者に見せるデッサン画像）
export async function saveFigure(blob, name, dest = 'captures') {
  const form = new FormData();
  form.append('file', blob, name);
  form.append('name', name);
  form.append('dest', dest);
  const res = await fetch(`${apiUrl()}/capture`, { method: 'POST', body: form });
  if (!res.ok) throw new Error(`/capture ${res.status}`);
}

// 置いてある画像を取り直す（キャッシュを使わない）。無ければ null
export async function fetchCurrent(url) {
  const res = await fetch(`${url}?v=${Date.now()}`, { cache: 'no-store' });
  const type = res.headers.get('content-type') || '';
  // 開発サーバーは存在しないパスに index.html を返すので、画像以外は「無い」とみなす
  if (!res.ok || !type.startsWith('image/')) return null;
  return res.blob();
}

// 2枚の画像で、色が変わった画素の数を数える（大きさが違えば全画素を変化とみなす）
export async function countDiffPixels(a, b) {
  const [ia, ib] = await Promise.all([createImageBitmap(a), createImageBitmap(b)]);
  if (ia.width !== ib.width || ia.height !== ib.height) return ia.width * ia.height;
  const read = (bmp) => {
    const c = document.createElement('canvas');
    c.width = bmp.width;
    c.height = bmp.height;
    const ctx = c.getContext('2d');
    ctx.drawImage(bmp, 0, 0);
    return ctx.getImageData(0, 0, c.width, c.height).data;
  };
  const da = read(ia);
  const db = read(ib);
  let diff = 0;
  for (let i = 0; i < da.length; i += 4) {
    if (da[i] !== db[i] || da[i + 1] !== db[i + 1] || da[i + 2] !== db[i + 2]) diff += 1;
  }
  return diff;
}
